<template>

	<div class="wrapper">
		<div class="section section-blogs-2 topsearch">
			<div class="container main">
				<div class="md-layout">
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<router-link :to="{ name: 'modelList', params: {dictionaryId: dictCode, page: page} }"
									 id="buttonback">
							<md-icon>keyboard_arrow_left</md-icon>
							Назад к списку справочников
						</router-link>
					</div>
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">

						<div class="name">
							<h3 class="title">Редактирование элемента справочника моделей окон</h3>
							<div class="md-layout-item md-size-100 md-xsmall-size-100 fieldsep" v-if="selectedDataId">

								<div class="md-layout-item md-size-50 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('modelName')">
										<label>{{mapElementName['modelName']}}</label>
										<md-input type="text" v-if="action === 'delete'"
												  v-model="form['modelName']"></md-input>
										<md-input type="text" v-else v-model="form['modelName']"></md-input>
										<span class="md-error" v-if="!$v.form.modelName.required">Обязательно для заполнения</span>
									</md-field>
								</div>
								<div class="md-layout-item md-size-50 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('modelOrder')">
										<label>{{mapElementName['modelOrder']}}</label>
										<md-input type="text" v-if="action === 'delete'"
												  v-model="form['modelOrder']"></md-input>
										<md-input type="text" v-else v-model="form['modelOrder']"></md-input>
										<span class="md-error" v-if="!$v.form.modelOrder.required">Обязательно для заполнения</span>
									</md-field>
								</div>

								<div class="md-layout-item text-center fieldsep">
									<md-field>
										<label>{{mapElementName['modelDesc']}}</label>
										<md-textarea type="text" v-if="action === 'delete'"
													 v-model.number="form['modelDesc']"></md-textarea>
										<md-textarea type="text" v-else v-model="form['modelDesc']"></md-textarea>
									</md-field>
								</div>

								<h4 class="title">Параметры</h4>
                                <template v-if="windowParams.length > 0">
                                    <div :key="index"
                                        class="md-layout-item md-size-50 md-xsmall-size-100 text-center fieldsep"
                                        v-for="(item, index) in windowParams.filter(param => param.paramType === 'V')"
                                        
                                    >
                                        <md-field :class="getValidationClass('param')">
                                            <label>{{ item.typeName }}</label>
                                            <md-select :value="getParamVal(item.id)"
                                                    @md-selected="setParamVal(item.id, $event)"
                                                    md-dense
                                                    name="paramType"
                                            >
                                                <md-option :value="param.typeValVal"
                                                        v-for="(param, index) in _.orderBy(item.values, 'typeValVal', 'asc')"
                                                        :key="`${ param.typeValVal }:${ param.typeValDesc }`"
                                                >{{ param.typeValVal }}: {{ param.typeValDesc }}
                                                </md-option>
                                            </md-select>
                                        </md-field>
                                    </div>
                                </template>

								<h4 class="title">Технические Параметры</h4>
								<div class="md-layout-item md-size-50 md-xsmall-size-100 text-center fieldsep"
									 v-for="(item, index) in form.techParams"
									 :key="`techParams${index}`"
								>
									<md-field :class="getValidationClass('param')">
										<label>{{ item.paramName }}</label>
										<md-input type="text"
												  v-if="action === 'delete'"
												  v-model="form['techParams'][index].typeValVal"></md-input>
										<md-input type="text" v-else
												  v-model="form['techParams'][index].typeValVal"></md-input>
									</md-field>
								</div>

								<h4 class="title">Фотографии</h4>
								<h5>Фото:</h5>
								<img :src="itemPhoto" v-if="itemPhoto">
								<div style="margin-top: 10px;">
									<label>Выбрать фото
										<input id="photo" ref="photo" type="file"
											   v-on:change="handleFileUpload('photo')"/>
									</label>
								</div>
								<h5>Большое фото:</h5>
								<img :src="itemBigPhoto" v-if="itemBigPhoto">
								<div style="margin-top: 10px;">
									<label>Выбрать большое фото
										<input id="bigPhoto" ref="bigPhoto" type="file"
											   v-on:change="handleFileUpload('bigPhoto')"/>
									</label>
								</div>
							</div>
							<br/>
							<div class="md-layout-item md-gutter md-size-100 md-xsmall-size-100 fieldsep">

								<template v-if="selectedDataId">
									<md-button @click="validateData(saveItem)"
											   class="md-button md-success md-theme-default"
											   v-if="action !== 'delete'">
										Сохранить
									</md-button>

									<md-button @click="validateData(deleteItem)"
											   class="md-button md-primary  md-theme-default"
											   v-if="action === 'delete'">
										Удалить
									</md-button>

								</template>
							</div>
						</div>

					</div>
				</div>

			</div>
		</div>
		<md-dialog-alert
				:md-active.sync="alert"
				:md-content="alertText"
				md-confirm-text="OK" />
	</div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import { checkAuthentication, reAuthenticate } from '@/utils/auth-api'
    import { required, minValue } from 'vuelidate/lib/validators'
    import { saveItem, getItem, uploadFile, getFile, deleteItem } from '@/utils/dict-api'
	import _ from 'lodash'

    export default {
        mixins: [
            validationMixin,
        ],
        components: {},
        bodyClass: 'dictionary-data',
        props: ['page', 'action'],
        data () {
            return {
                alert: false,
                alertText: '',
                options: [],
                dictCode: this.$route.params.dictCode,
                dictionaryId: '',
                selectedDataId: this.$route.params.id,
                selectedData: null,
                form: {
                    action: 'save',
                    modelName: '',
                    modelDesc: '',
                    photo: '',
                    bigPhoto: '',
                    modelOrder: 1
                },
                itemData: {},
                photo: '',
                bigPhoto: '',
                mapElementName: {
                    'modelOrder': 'Порядок отображения',
                    'modelName': 'Название',
                    'modelDesc': 'Описание',
                },
                windowParams: [],
            }
        },
        computed: {
            _ () {
                return _
			},
            itemPhoto: function () {
                if (this.itemData.photo)
                    return getFile(this.itemData.photo)
            },
            itemBigPhoto: function () {
                if (this.itemData.bigPhoto)
                    return getFile(this.itemData.bigPhoto)
            },
        },
        validations: {
            form: {
                modelName: {
                    required,
                },
                modelOrder: {
                    required,
                },
                photo: {
                    required,
                    minValue: minValue(1)
                },
                bigPhoto: {
                    required,
                    minValue: minValue(1)
                }
            },
        },
        methods: {
            getParamVal (paramId) {
                if (!this.form.params || !paramId) return false
                let res = this.form.params.find(item => item.typeId === paramId)
                return res ? res.typeValVal : false
            },
            setParamVal (paramId, val) {
                if (!val || !paramId) return

                let paramIndex = this.form.params.findIndex(item => item.typeId === paramId)
				let paramVal = this.windowParams
				  .find(item => item.id === paramId)
				  .values.find(item => item.typeValVal === val)
				if (!paramVal) return

                if (paramIndex > -1) {
                    this.form.params.splice(paramIndex, 1, paramVal)
                } else {
                    this.form.params.push(paramVal)
				}
            },
            handleFileUpload (name) {
                this[name] = this.$refs[name].files[0]
				this.submitFile(name)
            },
            submitFile (name) {
                let formData = new FormData()
                formData.append('file', this[name])
                uploadFile(formData).then(response => {
                    this.itemData[name] = response.id
                    this.form[name] = response.id
                })
            },
            getValidationClass (fieldName) {
                const field = this.$v.form[fieldName]
                if (field) {
                    return {
                        'md-invalid': field.$invalid && field.$dirty,
                    }
                }
            },
            validateData (sendFn) {
                this.$v.form.$touch()
                if (!this.form.photo || !this.form.bigPhoto) {
                    this.alertText = "Не добавлены фото"
                    this.alert = true
                    return
                }
                _.forEach(this.form.techParams, item => {
                    if(!item.typeValVal || item.typeValVal.length === 0) {
                        this.alert = true
                        return
					}
				})
				if(this.alert) {
                    this.alertText = "Не все технические параметры заполнены"
					return
				}
                _.forEach(this.form.params, item => {
                    if(!item.typeValVal) {
                        this.alert = true
                        return
                    }
                })
                if(this.alert) {
                    this.alertText = "Не все параметры заполнены"
                    return
                }
                if (this.$v.form.$invalid) {
                    this.alertText = "Не все поля заполнены"
					this.alert = true
					return
				}
                if (!this.$v.form.$invalid) {
                    sendFn()
                }
            },
            setData: function (data) {
                this.itemData = { ...data }
                this.form = { ...data }
            },
            getElementData: function () {
                checkAuthentication(this.$router, this.$route).then(response => {
                    getItem('windowparamtype').then(result => {
                        this.windowParams = result
                        if (this.selectedDataId === 'new') {
                            this.addItem()
                        }
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })

                    if (this.selectedDataId === 'new') return
                    getItem('window', this.selectedDataId).then(result => {
                        this.setData(result)
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
            addItem: function () {
                const item = {
                    'id': 'new',
                    'modelName': '',
                    'modelDesc': '',
                    'photo': 0,
                    'bigPhoto': 0,
                    'modelOrder': 1,
                    'params': [],
                    'techParams': [],
                }
                this.windowParams.filter(param => param.paramType === 'V').forEach(param => {
                    item.params.push({ ...param.values[0] })
                })
                this.windowParams.filter(param => param.paramType === 'S').forEach(param => {
                    item.techParams.push({
                        paramId: param.id,
                        paramName: param.typeName,
                        typeValVal: '',
                        typeId: param.id,
                    })
                })

                this.setData(item)

            },
            deleteItem: function () {
                checkAuthentication(this.$router, this.$route).then(response => {
                    deleteItem('window', JSON.stringify({ id: this.$route.params.id })).then(result => {
                        this.$router.push({ name: 'modelList', params: { dictCode: 'modelList' } })

                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
            saveItem: function () {
                if (this.form.id === 'new') {
                    this.form.id = null
                }
                saveItem('window', JSON.stringify(this.form)).then(result => {
                    this.$router.push({ name: 'modelList', params: { dictCode: 'modelList' } })
                }).catch(error => {
                    reAuthenticate(this.$router, this.$route, error)
                })
            },
            checkEditableNames: function (name) {
                const editableNames = ['valueId', 'value', 'modelOrder']
                return (editableNames.indexOf(name) >= 0)
            },
        },
        created () {
            if (this.$route.params.action === 'delete') {
                this.deleteItem()
            } else {
                this.getElementData()
            }
        },
    }
</script>


<style lang="scss" scoped type="text/scss">
	.dictionary-data .md-field {
		padding-top: 16px;
		margin: 4px 0 24px;
	}

	.offset-left-16 {
		margin-left: 16px;
	}
</style>




